/* import __COLOCATED_TEMPLATE__ from './highpass-firstorder.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();